import { Component, Input } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { ExtendedOrderType } from '../../../core/enums';
import { SearchResult } from '../../../core/models';
import { RouterModule } from '@angular/router';
import { TranslocoCurrencyPipe } from '@jsverse/transloco-locale';
import { PricePipe } from '../../../core/pipes/price.pipe';

@Component({
	selector: 'app-product-popover',
	standalone: true,
	imports: [
		RouterModule,
		TranslocoPipe,
		TranslocoCurrencyPipe,
		PricePipe
	],
	templateUrl: './product-popover.component.html',
	styleUrls: ['./product-popover.component.css'],
})
export class ProductPopoverComponent {
	@Input() product: SearchResult;

	ExtendedOrderType = ExtendedOrderType;

	constructor(public translate: TranslocoService) { }

}
